const Requirements = ({
  height = '20px',
  width = '20px',
  stroke = '#2A3135',
  fill = '#2A3135',
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <g
      transform="translate(2 2)"
      stroke={stroke}
      fill="none"
      fillRule="evenodd"
    >
      <rect strokeWidth="1.8" width="16" height="16" rx="3" />
      <path
        d="M12.314 5.18a.585.585 0 00-.845 0L7.034 9.867 5.03 7.751a.585.585 0 00-.86.016.67.67 0 000 .893l2.433 2.57c.237.251.622.251.86 0l4.865-5.14a.669.669 0 00-.015-.91z"
        strokeWidth=".5"
        fill={fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default Requirements;
